// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_bag = /** @type {(inputs: {}) => string} */ () => {
	return `Bag`
};

const el_bag = /** @type {(inputs: {}) => string} */ () => {
	return `Καλάθι`
};

const ru_bag = /** @type {(inputs: {}) => string} */ () => {
	return `Корзина`
};

const he_bag = /** @type {(inputs: {}) => string} */ () => {
	return `סל`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bag = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bag(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bag", locale)
	if (locale === "en") return en_bag(inputs)
	if (locale === "el") return el_bag(inputs)
	if (locale === "ru") return ru_bag(inputs)
	if (locale === "he") return he_bag(inputs)
	return "bag"
};